import { type ConsolidatedSession } from '@/features/consolidatedSessionsList/types';

/**
 * Gets the unique identifier for a consolidated session.
 * Prefers session_id, falls back to ehr_appt_id for EHR appointments.
 */
export function getSessionUniqueId(
  consolidatedSession: ConsolidatedSession
): string | null {
  return consolidatedSession.session_id ?? consolidatedSession.ehr_appt_id ?? null;
}
